// extracted by mini-css-extract-plugin
export default {"half":"GkOmL","half--max":"QurhW"};